module.exports = __webpack_public_path__ + "img/IcnLine.bc40ab67.png";